import angular from "angular";
import AdminCreateStudentController from "./create-student.controller";
import template from "./create-student.html";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.create", {
    url: "/create",
    controller: AdminCreateStudentController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.create", [])
  .config(config)
  .controller("AdminCreateStudentController", AdminCreateStudentController);
